import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { finalize } from 'rxjs/operators'

import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-sign-up-form',
  templateUrl: './bmcore-sign-up-form.component.html',
  styleUrls: ['./bmcore-sign-up-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSignUpFormComponent implements OnInit {
  lg: LgType
  signUpForm: UntypedFormGroup
  isLoader = false

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.signUpForm = this.formBuilder.group({
      nickname: [],
      email: [],
      password: [],
      confirmPassword: []
    })
  }

  onSubmit() {
    if (this.signUpForm.valid) {
      const { nickname, email, password, confirmPassword } = this.signUpForm.value

      if (password.password === confirmPassword.confirmPassword) {
        this.isLoader = true

        this.authService
          .registration(email.email, nickname.nickname, password.password)
          .pipe(finalize(() => (this.isLoader = false)))
          .subscribe(
            res => {
              if (res.resultCode === ResultCode.Success) {
                // Если все ОК, то пользователь получит следующую ссылку
                // https://beatmakers.tv/confirm-email?code=b271cfef-23f2-410d-aad3-ba6f1362b666"
                this.router.navigate(['/check-email', { email: email.email, path: 'signUp' }])
              } else {
                this.notificationService.handleError(res.messages[0])
              }
            },
            err => this.notificationService.handleError(err.message)
          )
      } else {
        this.notificationService.handleError(this.lg.forms.passwordsDontMatch)
      }
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
